<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-textarea-docs-preview></ui-textarea-docs-preview></p>
<h1 id="description">Description</h1>
<p>Default button.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-textarea</span> <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"Write some..."</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-textarea</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">id</td>
<td align="left">ID.</td>
</tr>
<tr>
<td align="left">placeholder</td>
<td align="left">Placeholder text.</td>
</tr>
<tr>
<td align="left">blurOnSubmit</td>
<td align="left">Blur text field on submit</td>
</tr>
<tr>
<td align="left">invisibleBorders</td>
<td align="left">Blur text field on submit</td>
</tr>
<tr>
<td align="left">value</td>
<td align="left">Value.</td>
</tr>
<tr>
<td align="left">maxRows</td>
<td align="left">Maximum amount of rows allowed.</td>
</tr>
<tr>
<td align="left">maxCharacters</td>
<td align="left">Maximum amount of characters allowed.</td>
</tr>
<tr>
<td align="left">public</td>
<td align="left">Autofocus automatically sets focus to the input when the input component is initialized</td>
</tr>
<tr>
<td align="left">disabled</td>
<td align="left">Disable any input.</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">valueChange</td>
<td align="left">Change event.</td>
</tr>
<tr>
<td align="left">submit</td>
<td align="left">Submit event.</td>
</tr>
</tbody></table>
